import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import joi from 'joi';

import TextField from '@mui/material/TextField';

const MfaCode = (props) => {
	const {
		disabled,
		errors,
		id,
		label,
		onInputChange,
		onInputFocus,
		required,
		value,
		...styleProps
	} = props;
	const schemaDefinition = {};

	const { t } = useTranslation('inputs');

	schemaDefinition[id] = joi.number().min(6).required();
	const schema = joi.object(schemaDefinition);

	const handleErrorText = () => {
		if (!errors?.[id]) {
			return null;
		}

		return errors[id];
	};

	const handleOnChange = (e) => {
		onInputChange(e.target.value, id, schema);
	};

	return (
		<TextField
			disabled={disabled}
			{...styleProps}
			sx={{ flex: 1 }}
			name={id}
			label={t('mfaCode.value')}
			onChange={handleOnChange}
			onFocus={onInputFocus}
			size="small"
			slotProps={{
				inputLabel: {
					shrink: true
				}
			}}
			helperText={handleErrorText()}
			error={!!errors?.[id]}
			defaultValue={value || ''}
		/>
	);
};

MfaCode.propTypes = {
	disabled: PropTypes.bool,
	errors: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
	id: PropTypes.string.isRequired,
	label: PropTypes.string,
	onInputChange: PropTypes.func,
	onInputFocus: PropTypes.func,
	required: PropTypes.bool,
	value: PropTypes.string
};

export default MfaCode;
